import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import RestaurantSiteHeader from '../online-ordering/RestaurantSiteHeader/RestaurantSiteHeader.jsx';
import NetworkErrorState from '../online-ordering/NetworkErrorState/NetworkErrorState';
import RestaurantBootstrapLoader from '../online-ordering/RestaurantBootstrapLoader/RestaurantBootstrapLoader';
import { useRestaurantBootstrap } from '../../hooks/useRestaurantBootstrap';

function Content() {
	const {
		restaurantSlug,
		isLoading,
		isFailed,
		isReady,
		error,
		retry,
	} = useRestaurantBootstrap();

	return (
		<AppSettings.Consumer>
			{({ appContentClass }) => {
				if (restaurantSlug && isFailed) {
					return (
						<div className={`app-content ${appContentClass} app-content--bootstrap-error`}>
							<NetworkErrorState
								message={error || "We couldn't load this restaurant. Please try again."}
								onRetry={retry}
							/>
						</div>
					);
				}

				const chromeLoading = Boolean(restaurantSlug && isLoading);
				const chromeReady = Boolean(restaurantSlug && isReady);

				return (
					<div className={`app-content ${appContentClass}`}>
						{restaurantSlug ? (
							<RestaurantSiteHeader chromeLoading={chromeLoading} chromeReady={chromeReady} />
						) : null}
						{chromeReady ? (
							<Outlet />
						) : restaurantSlug && chromeLoading ? (
							<RestaurantBootstrapLoader />
						) : (
							<Outlet />
						)}
					</div>
				);
			}}
		</AppSettings.Consumer>
	);
}

export default Content;
